import React, { useMemo, useEffect, useState, useCallback } from 'react';

import { buildAnchorLink } from '../../utils/helpers';


const NAKED_NEWS_LIVE_ID = 241;
const FANZONE_FILTER = '?filter=fanzone';
const NNL_USER_DATA = {
  id: NAKED_NEWS_LIVE_ID,
  name: 'Naked News Live',
};


const SpotlightChatNotificationLabel = (props) => {
  const { broadcastingTemptationNickname, spotlights, currentAnchor, anchors } = props;
  const [currentAnchorIsSpotlighting, setCurrentAnchorIsSpotlighting] = useState();
  const [spotlightsWithoutCurrentAnchor, setSpotlightsWithoutCurrentAnchor] = useState([]);
  const [highlightedSpotlight, setHighlightedSpotlight] = useState([]);
  const [anchorPageUrl, setAnchorPageUrl] = useState('');

  const loggedInUserIsCurrentAnchor = useMemo(() =>
    spotlights.find((spotlight) =>
      spotlight.isSpotlightByTemptationId === currentAnchor), [spotlights, currentAnchor]);

  const spotlightsExcludingCurrentAnchor = useMemo(() =>
    spotlights.filter((spotlight) =>
      spotlight.isSpotlightByTemptationId !== currentAnchor), [spotlights, currentAnchor]);

  const randomSpotlightAnchorFromList = useMemo(() =>
    spotlightsWithoutCurrentAnchor?.[Math.floor(Math.random() * spotlightsWithoutCurrentAnchor?.length)]
  , [spotlightsWithoutCurrentAnchor]);

  const remainingParticipantsCount = useMemo(() => {
    const currentAnchorCount = currentAnchorIsSpotlighting ? 0 : 1;

    return spotlightsWithoutCurrentAnchor.length - currentAnchorCount || '';
  }, [currentAnchorIsSpotlighting, spotlightsWithoutCurrentAnchor.length]);


  const highlightedSpotlightIsNakedNewsAnchor = useCallback((id) => {
    const anchorIsCurrent = anchors?.currentAnchors?.find((anchor) => anchor.id === id);
    const anchorIsGuest = anchors?.guestAnchors?.find((anchor) => anchor.id === id);

    if (id === NAKED_NEWS_LIVE_ID) {
      return NNL_USER_DATA;
    }

    return anchorIsCurrent || anchorIsGuest;
  }, [anchors?.currentAnchors, anchors?.guestAnchors]);

  useEffect(() => {
    if (spotlights.length > 1) {
      setHighlightedSpotlight([randomSpotlightAnchorFromList]);
    }
    setCurrentAnchorIsSpotlighting(loggedInUserIsCurrentAnchor);
    setSpotlightsWithoutCurrentAnchor(spotlightsExcludingCurrentAnchor);
  }, [
    loggedInUserIsCurrentAnchor,
    randomSpotlightAnchorFromList,
    spotlights.length,
    spotlightsExcludingCurrentAnchor,
    spotlightsWithoutCurrentAnchor.length,
  ]);


  const getAnchorPageUrl = useCallback((anchorObject) => {
    let anchorPage = '';
    if (highlightedSpotlight?.length && anchorObject?.id) {
      anchorPage = buildAnchorLink(anchorObject, FANZONE_FILTER, true);

      return anchorPage;
    }

    if (anchorObject?.id === NAKED_NEWS_LIVE_ID) {
      anchorPage = '/live';

      return anchorPage;
    }

    if (spotlightsWithoutCurrentAnchor?.length && anchorObject?.id) {
      anchorPage = buildAnchorLink(anchorObject, FANZONE_FILTER, true) || '';

      return anchorPage;
    }

    return anchorPage;
  }, [highlightedSpotlight, spotlightsWithoutCurrentAnchor]);

  const setAnchorPageUrlForHighlightedSpotlight = useCallback(() => {
    const id = highlightedSpotlight[0]?.isSpotlightByTemptationId ||
      spotlightsWithoutCurrentAnchor[0]?.isSpotlightByTemptationId;
    const highlightedAnchorDataFromNakedNews = highlightedSpotlightIsNakedNewsAnchor(id);
    const anchorPage = getAnchorPageUrl(highlightedAnchorDataFromNakedNews);
    if (highlightedAnchorDataFromNakedNews) {
      setAnchorPageUrl(anchorPage);
    } else {
      setAnchorPageUrl('');
    }
  }, [getAnchorPageUrl, highlightedSpotlight, highlightedSpotlightIsNakedNewsAnchor, spotlightsWithoutCurrentAnchor]);

  useEffect(() => {
    setAnchorPageUrlForHighlightedSpotlight();
  }, [setAnchorPageUrlForHighlightedSpotlight]);

  if (currentAnchorIsSpotlighting && !spotlightsWithoutCurrentAnchor.length) {
    return `${currentAnchorIsSpotlighting?.isSpotlightByTemptationNickname} is spotlighting ${broadcastingTemptationNickname}`;
  }

  if (!currentAnchorIsSpotlighting && spotlightsWithoutCurrentAnchor?.length === 1) {
    return (
      <>
        <a href={anchorPageUrl} rel="noreferrer" target="_blank" >
          {spotlightsWithoutCurrentAnchor[0]?.isSpotlightByTemptationNickname}
        </a> is spotlighting {broadcastingTemptationNickname}
      </>
    );
  }

  return (
    <>
      <a href={anchorPageUrl} rel="noreferrer" target="_blank" >
        {highlightedSpotlight[0]?.isSpotlightByTemptationNickname}
      </a> and {remainingParticipantsCount} others are spotlighting {broadcastingTemptationNickname}.
    </>
  );
};

export default SpotlightChatNotificationLabel;
